export default function projectViews_checkIsOldSystemView(view: any) {
    return !view.id || view.id.toString().length < 3
}